<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import { mapGetters } from 'vuex'

import Resizable from '@src/mixins/resizable.js'
import Translatable from '@src/mixins/translatable.js'
import ExampleDay from '@components/pass-and-card/example-day.vue'

export default {
  mixins: [
    Resizable,
    Translatable
  ],
  components: {
    ExampleDay,
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      howToUseSliderOptions: {
        allowTouchMove: true,
        spaceBetween: 20,
        pagination: {
          el: '.pagination',
          clickable: true,
          bulletClass: 'bullet',
          bulletActiveClass: 'bullet-active'
        },
        breakpoints: {
          320: {
            slidesPerView: 1.1,
            slidesPerGroup: 1.1,
          },
        }
      },
      total: 0,
      totalWithCoolpass: 0
    }
  },
  computed: {
    ...mapGetters('passAndCard', [
      'pageData',
    ]),
    ...mapGetters('translations', [
      'currentLanguage'
    ]),
    ...mapGetters('calculator', [
      'cards'
    ]),
    ...mapGetters('eShop', [
      'pageDataCurrency'
    ]),
    daysData() {
      return this.pageData.exampleDays ? Object.values(this.pageData.exampleDays) : []
    },
  },
  watch: {
    daysData() {
      this.setPrice()
    }
  },
  mounted() {
    this.$store.subscribe(((mutation, state) => {
      if (mutation.type === 'calculator/SET_CARDS' && this.daysData.length) {
        if (this.daysData.length) {
          this.setPrice()
        }
      }
    }))
    this.$nextTick(() => {
      if (this.daysData.length) {
        this.setPrice()
      }
    })
  },
  methods: {
    setPrice() {
      const withoutPass = this.daysData.flat()
      .reduce((sum, attraction) => sum + +attraction.priceAdult, 0)
      const withPass = this.cards[2] ? this.cards[2].priceAdultFixedCZK : withoutPass

      this.total = withoutPass.toFixed(0)
      this.totalWithCoolpass = withPass.toFixed(0)
    }
  },
}
</script>

<template>
  <div class="wrapper">
    <div v-if="desktopScreen" class="example-day">
      <ExampleDay
        v-for="(item, index) in daysData"
        :key="index"
        :attractions="daysData[index]"
        :day="index + 1"
      />
    </div>
    <div v-else class="example-day-slider">
      <Swiper :options="howToUseSliderOptions">
        <SwiperSlide v-for="(item, index) in daysData" :key="index" class="example-day-slide">
          <ExampleDay
            :attractions="daysData[index]"
            :day="index + 1"
          />
        </SwiperSlide>
        <div class="pagination" slot="pagination"></div>
      </Swiper>
    </div>
    <div class="result">
      <div class="total">
        <div class="total-el">
          <h4 class="total-el-title">{{ getTranslatedContent('PASS_AND_CARD_total_entry_price_label') }}</h4>
          <p class="total-el-price">{{ total | KC }}</p>
        </div>
          <div class="total-el">
            <h4 class="total-el-title">{{ getTranslatedContent('PASS_AND_CARD_cost_with_coolpass') }}</h4>
            <p class="total-el-price">{{ totalWithCoolpass | KC }}</p>
        </div>
        <h4 class="content-text">{{ getTranslatedContent('PASS_AND_CARD_benefit_label') }}</h4>
      </div>
      <router-link :to="{ name: 'attractions' }">
        <button class="button">{{ getTranslatedContent('PASS_AND_CARD_calculate_my_trip') }}</button>
      </router-link>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
.example-day {
  display: grid;
  margin-top: 30px;
  column-gap: 20px;
  grid-template-columns: repeat(3, 1fr);
}

.result {
  display: flex;
  margin-top: 29px;
}

.total {
  width: 754px;
}

.total-el {
  display: flex;
  justify-content: space-between;
  height: 23px;
  padding: 10px 0 6px;
  border-bottom: 1px solid $dark-gray;
  font-family: Open Sans, sans-serif;
  font-weight: normal;
  font-size: 18px;
  line-height: 23px;
}

.total-el-title {
  color: $dark-blue;
}

.total-el-price {
  font-family: Open Sans Bold, sans-serif;
  font-weight: bold;
  color: $black;
}

.content-text {
  font-family: Open Sans Bold, sans-serif;
  font-weight: bold;
  font-size: 18px;
  line-height: 23px;
  color: $orange;
  text-transform: uppercase;
  margin-top: 23px;
}

.button {
  min-width: 305px;
  max-width: 305px;
  min-height: 48px;
  padding: 0 20px;
  border: 1px solid $orange;
  border-radius: 5px;
  background: $orange;
  color: $white;
  font-family: Open Sans Bold, sans-serif;
  font-weight: bold;
  font-size: 15px;
  line-height: 19px;
  margin-left: 50px;

  &:hover {
    border: none;
    background: $hover-orange;
    color: $white;
  }
}

@media only screen and (min-width: $mobile-screen-width) and (max-width: $container-width-xs) {
  .example-day {
    display: grid;
    margin-top: 30px;
    column-gap: 20px;
    grid-template-columns: repeat(1, 1fr);
  }

  .example-day-slider {
    margin-top: 15px;
  }

  .pagination {
    margin-top: 15px;
  }

  .result {
    flex-direction: column;
    margin-top: 5px;
  }

  .total {
    width: 100%;
  }

  .total-el {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    height: auto;
    padding: 10px 0 6px;
    border-bottom: 1px solid $dark-gray;
    font-size: 14px;
    line-height: 23px;
  }

  .total-el-title {
    width: 181px;
  }

  .button {
    min-width: 100%;
    margin: 10px 0 0;
  }
}
</style>
